import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from "draft-js";
// import { convertToHTML } from "draft-convert";

import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
// import DOMPurify from "dompurify";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./RichTextEditor.css";
import { isRichTextEditorContentEmpty } from "../../constants";

import { useStoreState, useStoreActions } from "easy-peasy";

export default function RichTextEditor({ contentKey = "", defaultContent = "" }) {
  // const formElementsData = useStoreState((state) => state.formElementsData);
  const updFormElementsPDF = useStoreActions((actions) => actions.updFormElementsPDF);
  const formElementsPDF = useStoreState((state) => state.formElementsPDF);
  const currentEl = formElementsPDF.filter((item) => {
    return item.isEdit === true;
  });

  const [editorState, setEditorState] = useState(() => {
    EditorState.createEmpty();
  });
  const [convertedContent, setConvertedContent] = useState(null);
  const editorDisplay = useStoreState((state) => state.editorDisplay);

  useEffect(() => {
    let currentEl = formElementsPDF.filter((item) => {
      return item.isEdit === true;
    });
    if (currentEl && currentEl[0]) {
      setEditorState(() => {
        if (editorDisplay) {
          const content = contentKey ? currentEl[0].formElementData[contentKey] : currentEl[0].formElementData.content;
          if (isRichTextEditorContentEmpty(content)) {
            // If there is no content, use the default content if provided
            if (defaultContent) {
              const contentBlock = htmlToDraft(defaultContent);
              const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
              return EditorState.createWithContent(contentState);
            }
            // If there is no default content, return an empty editor state
            return EditorState.createEmpty();
          }
          const contentBlock = htmlToDraft(content);
          const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
          return EditorState.createWithContent(contentState);
        } else {
          return EditorState.createEmpty();
        }
      });
    }
  }, [editorDisplay]);

  const handleEditorChange = (state) => {
    setEditorState(state);
    convertContentToHTML();
  };
  const convertContentToHTML = () => {
    let currentContentAsHTML = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    setConvertedContent(currentContentAsHTML);
    updFormElementsPDF(
      formElementsPDF.map(function (item, i) {
        if (item.isEdit === true) {
          // Update the content of the current element being edited
          let currentFormElement = {
            ...item.formElementData,
          };
          if (contentKey) {
            currentFormElement[contentKey] = currentContentAsHTML;
          } else {
            currentFormElement.content = currentContentAsHTML;
          }
          return { ...item, formElementData: currentFormElement };
        } else {
          return item;
        }
      })
    );
  };

  return (
    <>
      <Editor
        toolbar={{
          options: [
            "inline",
            "blockType",
            "fontSize",
            "fontFamily",
            "list",
            "textAlign",
            "colorPicker",
            "link",
            "remove",
            "history",
          ],
          inline: {
            inDropdown: false,
            className: undefined,
            component: undefined,
            dropdownClassName: undefined,
            options: ["bold", "italic", "underline"],
          },
          fontFamily: {
            options: ['Gothic A1', 'Poppins', 'Roboto',
            'Ubuntu', 'DancingScript-VariableFont_wght'],
            className: undefined,
            component: undefined,
            dropdownClassName: undefined,
          },
        }}
        editorState={editorState}
        onEditorStateChange={handleEditorChange}
        wrapperClassName="wrapper-class"
        editorClassName="editor-class"
        toolbarClassName="toolbar-class"
      />
    </>
  );
}
